import useIsNarrow from "../hooks/useIsNarrow";

/**
 * The AI rent prediction, as a client should see it: the number, the range, the reasoning.
 *
 * Deliberately NOT the analyst's AIPredictionAnalysis block from PredictionPage. That one
 * carries a comp-filter dropdown, a re-run button, a chat thread, a confidence rating, key-factor
 * chips and per-comp adjustment tables — all of it either an internal control the client must
 * not have, or a hedge that reads as uncertainty rather than information to someone outside the
 * team. What survives is the estimate and the argument for it.
 */
export default function AIRentSummary({ predictedRent, rentLow, rentHigh, reasoning }) {
  const narrow = useIsNarrow();
  if (!predictedRent) return null;

  const money = (v) => `$${Math.round(v).toLocaleString()}`;
  const hasRange = rentLow != null && rentHigh != null;

  return (
    <div style={cardStyle(narrow)}>
      <h2 style={headingStyle}>Estimated Rental Value</h2>

      <div style={{ display: "flex", gap: "40px", alignItems: "baseline", flexWrap: "wrap" }}>
        <div>
          <div style={captionStyle}>Predicted Rent</div>
          <div style={{ fontSize: "30px", fontWeight: 700, color: "#1976d2", lineHeight: 1.2 }}>
            {money(predictedRent)}<span style={{ fontSize: "16px", fontWeight: 600, color: "#666" }}>/mo</span>
          </div>
        </div>
        {hasRange && (
          <div>
            <div style={captionStyle}>Expected Range</div>
            <div style={{ fontSize: "19px", fontWeight: 600, color: "#333", lineHeight: 1.4 }}>
              {money(rentLow)} – {money(rentHigh)}
            </div>
          </div>
        )}
      </div>

      {reasoning && (
        <div style={{
          marginTop: "18px",
          padding: "14px 16px",
          backgroundColor: "#f7f9fc",
          border: "1px solid #e4eaf2",
          borderRadius: "6px",
          fontSize: "14px",
          lineHeight: 1.6,
          color: "#333",
        }}>
          {reasoning}
        </div>
      )}
    </div>
  );
}

const cardStyle = (narrow) => ({
  backgroundColor: "white",
  border: "none",
  borderRadius: "8px",
  padding: narrow ? "16px 12px" : "24px",
  marginBottom: "24px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
});

const headingStyle = {
  fontSize: "20px",
  fontWeight: "600",
  color: "#333",
  marginBottom: "16px",
  borderBottom: "2px solid #000",
  paddingBottom: "8px",
};

const captionStyle = {
  fontSize: "13px",
  color: "#666",
  marginBottom: "2px",
};
